export default __webpack_public_path__ + "static/media/Watch.256a9522.jpg";